import {
    StatsService
} from '@/common/api.service'
import {
    FETCH_STATS
} from '../actions.type'
import {
    SET_STATS
} from '../mutations.type'

export const MODULE_NAME = 'STATS'

const state = {
    stats: {},
    isLoading: true
}

const getters = {
    getStats (state) {
        return state.stats
    },
    isLoading (state) {
        return state.isLoading
    }
}

const actions = {
    // eslint-disable-next-line no-unused-vars
    [FETCH_STATS] ({
        commit
    }, {
        query = {},
        type = null
    }) {
        return StatsService.get(query, type).then(({
            data
        }) => {
            commit(SET_STATS, {
                data,
                type
            })
        }).catch((error) => {
            throw new Error(error)
        })
    }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [SET_STATS] (state, stats) {
        state.stats[stats.type] = stats.data
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true
}

